import { renderSlot as _renderSlot, mergeProps as _mergeProps, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_form_item = _resolveComponent("vxe-form-item");
  return _openBlock(), _createBlock(_component_vxe_form_item, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), _createSlots({
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
    _: 2
  }, [_renderList(_ctx.$slots, key => {
    return {
      name: key,
      fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _mergeProps({
        key: key
      }, scope))])
    };
  })]), 1040);
}